'use client';

import NextLink from 'next/link';
import { usePathname } from 'next/navigation';
import type { NavItem as NavItemType } from '../Header.types';
import { css } from '@onbeam/business-styled-system/css';
import { navItemStyles } from './NavItem.types';
import { isActivePath } from '../Header.utils';
import { ArrowDiagonalIcon } from '@onbeam/icons/business';

export const NavItem = ({ href, label, isExternal }: NavItemType) => {
  const pathname = usePathname();

  return href ? (
    <NextLink
      href={href}
      target={isExternal ? '_blank' : '_self'}
      rel="noopener noreferrer"
      data-active={isActivePath(pathname, href)}
      className={navItemStyles}
    >
      <div
        data-is-external={isExternal}
        className={css({
          mt: '[0.125rem]',
          '&[data-is-external="true"]': {
            display: 'inline-flex',
            alignItems: 'center',
            position: 'relative',
            transitionProperty: 'transform',
            transitionDuration: '[250ms]',
            transitionTimingFunction: 'ease',

            _groupHover: {
              transform: 'translateX(-16px)',
            },
          },
        })}
      >
        <span>{label}</span>
        {isExternal && (
          <ArrowDiagonalIcon
            height={16}
            width={16}
            className={css({
              position: 'absolute',
              top: '[50%]',
              right: '0',
              pr: '0.5',
              transform: 'translate(100%, -50%)',
            })}
          />
        )}
      </div>
    </NextLink>
  ) : (
    <button type="button" className={navItemStyles}>
      {label}
    </button>
  );
};
